<template>
  <div>
    <div v-show="loadingMyArtistInfo || loadingEdit" class="mv2 flex justify-center w-100">
      <clip-loader :loading="loadingMyArtistInfo || loadingEdit" :color="color" :size="size"></clip-loader>
    </div>
    <div v-show="!(loadingMyArtistInfo || loadingEdit)">
      <h3 class="textColor">{{$t("artists.info")}}</h3>
      <div class="flex flex-wrap">
        <div class="flex w-50-l w-100 h-100 ba">
          <div v-tooltip="{
                content: msg,
                placement: 'bottom-center',
                classes: 'my_tooltip',
                offset: 5,
                delay: {
                  show: 10,
                  hide: 10,
                },
              }"
               class="db w-100 cover center relative image-container flex items-start"
               :style=" { 'background-image': 'url(' + picture + ')'} ">
            <div v-show="files.length && files[0].progress < 100" class="flex justify-center items-center h-100 w-100">
              <clip-loader :loading="true" :color="color" :size="size"></clip-loader>
            </div>
            <div v-show="!files.length" class="flex justify-center">
              <file-upload
                class="ph2 pointer"
                :post-action="url"
                :headers="postFileHeaders"
                extensions="jpg,jpeg,png,webp"
                v-model="files"
                ref="imageUpload"
                @input-file="imageInputFile"
                @input-filter="imageInputFilter">
                <div class="edit-button bg-primary ma2 br-100 flex items-center justify-center pointer">
                  <font-awesome-icon class="white" icon="camera"/>
                </div>
              </file-upload>
            </div>
          </div>
        </div>
        <div v-show="myArtistInfo !== Object" class="w-50-l w-100 ph2">
          <p class="dark-red mh3 tc f7" v-if="error">{{error.message}}</p>
          <form @submit.prevent="updateArtist">
            <div class="mv2 w-100 flex flex-column">
              <label class="f7 textColor">{{$t("artists.name")}}</label>
              <input class="input f6 ph2" v-model="myArtistInfo.name" :disabled="!edit"/>
            </div>
            <div class="mv2 w-100 flex flex-column">
              <label class="f7 textColor">{{$t("artists.phrase")}}</label>
              <input class="input f6 ph2" v-model="myArtistInfo.phrase" :disabled="!edit"/>
            </div>
            <div class="mv2 w-100 flex flex-column">
              <label class="f7 textColor">{{$t("artists.text")}}</label>
              <input class="input f6 ph2" v-model="myArtistInfo.text" :disabled="!edit"/>
            </div>
            <div v-show="edit" class="flex justify-center">
              <input class="w-50-ns w-100 block mv2 pointer btn dim b f5 fw4" type="submit" :value="$t('app.save')">
            </div>
          </form>
        </div>
      </div>
    </div>
    <payment-info></payment-info>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import consts from '@/consts'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import FileUpload from 'vue-upload-component'
  import auth from '@/auth'
  import PaymentInfo from '@/components/user/PaymentInfo'

  export default {
    name: 'my-artist-info',
    data () {
      return {
        color: '#808080',
        size: '50px',
        files: [],
        msg: 'Img size 578x280'
      }
    },
    props: {
      edit: {
        required: true
      }
    },
    components: {
      ClipLoader,
      FontAwesomeIcon,
      FileUpload,
      PaymentInfo
    },
    computed: {
      ...mapGetters('artist', [
        'myArtistInfo',
        'error'
      ]),
      picture () {
        if (this.myArtistInfo.primary_picture) {
          return consts.MEDIA_BASE_URL + this.myArtistInfo.path + this.myArtistInfo.primary_picture
        } else {
          return '/static/assets/Img_generico_principal3.jpg'
        }
      },
      url () {
        return consts.API_BASE_URL + '/artists/uploadArtistPicture/primary_picture'
      },
      postFileHeaders: function () {
        return auth.getHeader()
      },
      loadingMyArtistInfo () {
        return this.$loading.isLoading('artist getMyArtistInfo')
      },
      loadingEdit () {
        return this.$loading.isLoading('artist editArtist')
      }
    },
    created () {
      this.getMyArtistInfo()
    },
    methods: {
      ...mapActions('artist', [
        'getMyArtistInfo',
        'editArtist',
        'updatePrimaryPicture'
      ]),
      updateArtist () {
        this.editArtist({
          name: this.myArtistInfo.name,
          phrase: this.myArtistInfo.phrase,
          text: this.myArtistInfo.text
        }).then(() => {
          // this.editTrigger()
        }).catch((e) => {
        })
      },
      imageInputFile: function (newFile, oldFile) {
        // auto start
        if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
          if (!this.$refs.imageUpload.active) {
            this.$refs.imageUpload.active = true
          }
        }
        if (newFile && oldFile) {
          if (newFile.success !== oldFile.success) {
            if (newFile.response) {
              if (newFile.response.status === 'error') {
                this.$toasted.show(this.$t('error.imageUpload'), {type: 'error'})
              } else {
                this.updatePrimaryPicture(newFile.response.data)
              }
              this.files = []
            }
          }
        }
      },
      imageInputFilter: function (newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          // Filter non-image file
          if (!/\.(jpg|jpeg|png|webp)$/i.test(newFile.name)) {
            this.$toasted.show(this.$t('tracks.newTrack.imageType'), {type: 'error'})
            return prevent()
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .input {
    color: #aaa !important;
    border: 1px solid #DDDEDF;
  }

  .image-container {
    height: 30vh;
    min-height: 30vh;
    background-position: center center;
  }

  .edit-button {
    min-width: 40px;
    min-height: 40px;
    widows: 40px;
    height: 40px;
  }

  @media screen and (max-width: 780px) and (min-width: 480px) {
    .artist-info {
      width: 75%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/MyArtistInfo.vue